import React from 'react';



const AppInfo = () => {


    return (
        <p
            style={{
                padding: '15vw',
                textAlign: "center"
            }}
        >
            {process.env.REACT_APP_VERSION}
            <br/>
            Env: {process.env.REACT_APP_NAME}
        </p>
    );
};


export default AppInfo;
